module.exports = "<h1>test</h1>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/superAdmin/users/accessDetails.component.html
// module id = ./src/app/superAdmin/users/accessDetails.component.html
// module chunks = main